import { makeStyles } from '@material-ui/core/styles';

export const DATE_WIDTH = 78;
export const PIN_WIDTH = 100;
export const PIN_WIDTH_COMPACT = 34;
export const AUDIENCE_WIDTH = 150;
export const AUTHOR_WIDTH = 150;
export const REPLIES_WIDTH = 44;
export const ROW_GAP = 18;
export const PANEL_WIDTH = 640;

export const PINNED_AMBER = '#FABE4D';

export const useBulletinRowStyles = makeStyles({
  columnHeader: {
    display: 'flex',
    alignItems: 'center',
    gap: ROW_GAP,
    padding: '9px 16px 9px 25px',
    borderLeft: '3px solid transparent',
    borderBottom: '1px solid #EFEFEF',
    backgroundColor: '#FAFAFA',
    flexShrink: 0,
  },
  row: {
    display: 'flex',
    alignItems: 'center',
    gap: ROW_GAP,
    padding: '12px 16px 12px 25px',
    borderBottom: '1px solid #F4F4F4',
    boxSizing: 'border-box',
    cursor: 'pointer',
    backgroundColor: (props: { selected?: boolean }) => (props.selected ? '#F4F2FF' : '#FFFFFF'),
    borderLeft: (props: { selected?: boolean }) =>
      props.selected ? `3px solid #796fff` : '3px solid transparent',
    '&:hover': {
      backgroundColor: (props: { selected?: boolean }) => (props.selected ? '#F4F2FF' : '#FAFAFA'),
    },
    '&:hover $pinAction': {
      visibility: 'visible',
    },
  },
  // Hidden until the row is hovered, the way the old bulletin cards behaved.
  pinAction: {
    visibility: 'hidden',
    display: 'flex',
    alignItems: 'center',
    gap: 4,
    color: '#9E9E9E',
    cursor: 'pointer',
    '&:hover': {
      color: PINNED_AMBER,
    },
  },
  pinnedChip: {
    display: 'flex',
    alignItems: 'center',
    gap: 4,
    padding: '2px 8px 2px 6px',
    borderRadius: 4,
    backgroundColor: PINNED_AMBER,
    color: '#FFFFFF',
  },
});
